import ProductItemService from './service';

export * from './reqres';

export default ProductItemService;
